import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({..._ctx.computedStyle, 'background-repeat': 'no-repeat', 'background-size': 'cover'}),
    class: "animate__animated animate__fadeIn"
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 4))
}